const tool = () => import(/* webpackChunkName: "tool" */ '@/views/page/tool/index.vue');
const love = () => import(/* webpackChunkName: "tool" */ '@/views/page/tool/love.vue');
const bags = () => import(/* webpackChunkName: "tool" */ '@/views/page/tool/bags.vue');
const shake = () => import(/* webpackChunkName: "tool" */ '@/views/page/tool/shake.vue');
const sx = () => import(/* webpackChunkName: "tool" */ '@/views/page/tool/sx.vue');
const bagSearch = () => import(/* webpackChunkName: "tool" */ '@/views/page/tool/bagSearch.vue');
const rotation = () => import(/* webpackChunkName: "tool" */ '@/views/page/tool/rotation.vue');
const turntable = () => import(/* webpackChunkName: "tool" */ '@/views/page/tool/turntable.vue')
const lotteryData = () => import(/* webpackChunkName: "tool" */ '@/views/page/tool/lotteryData.vue')
const secret = () => import(/* webpackChunkName: "tool" */ '@/views/page/tool/secret.vue')
const assistant = () => import(/* webpackChunkName: "tool" */ '@/views/page/tool/assistant.vue')
const notepad = () => import(/* webpackChunkName: "tool" */ '@/views/page/tool/notepad.vue')

const toolRoute = [
    {
        path: '/tool',
        name: 'tool',
        component: tool,
        meta: {
            keepAlive: true,
          },
    },
    {
        path: '/tool/love',
        name: 'love',
        component: love
    },
    {
        path: '/tool/sx',
        name: 'sx',
        component: sx
    },
    {
        path: '/tool/shake',
        name: 'shake',
        component: shake
    },
    {
        path: '/tool/bags',
        name: 'bags',
        component: bags
    },
    {
        path: '/tool/bags/search',
        name: 'bagSearch',
        component: bagSearch
    },
    {
        path: '/tool/rotation',
        name: 'rotation',
        component: rotation
    },
    {
        path: '/tool/turntable',
        name: 'turntable',
        component: turntable
    },
    {
        path: '/tool/lottery/data',
        name: 'lotteryData',
        component: lotteryData
    },
    {
        path: '/tool/secret',
        name: 'secret',
        component: secret
    },
    {
        path: '/tool/assistant',
        name: 'assistant',
        component: assistant
    },
    {
        path: '/tool/assistant/notepad',
        name: 'notepad',
        component: notepad
    },


    
        
    
]

export default toolRoute
